module.exports = __webpack_public_path__ + "img/button4.88283a1f.png";